﻿(function ($, document) {

    $(document).ready(function () {
        SetRadioButtonsIntoGroups();

        $('form').submit(function () {
            SetRadioButtonsIntoOriginalNames();
        });

        $('form').on('postback', function () {
            SetRadioButtonsIntoOriginalNames();
        });
    });

})(jQuery, document);


window.SetRadioButtonsIntoOriginalNames = function () {
    document.querySelectorAll('input[type=radio][data-group-name]').forEach(function (element) {
        element.name = element.dataset.originalName;
    });
};

window.SetRadioButtonsIntoGroups = function () {
    document.querySelectorAll('input[type=radio][data-group-name]').forEach(function (element) {
        element.dataset.originalName = element.name;
        element.name = element.dataset.groupName;
    });
};